import ApiRequestManagerInstance from '../ApiRequestManager';

function addKeepWatching(id: string) {
  const promise = new Promise<boolean>(async (resolve) => {
    try {
      await ApiRequestManagerInstance.post({
        endpoint: {
          url: 'apiUrl',
          version: 'v4',
          section: 'media',
          subsection: 'later',
          type: 'later',
          replacement: id,
        },
      });
      resolve(true);
    } catch (e) {
      console.error(e);
      resolve(false);
    }
  });

  return promise;
}

export default addKeepWatching;
